import { Cog } from '@sharefiledev/icons';
import type { PiletApi } from '@sharefiledev/sharefile-appshell';
import { addBlock, AsyncBlockDevelopmentPage } from './blocks';
import { setLogger } from './logger';
import { AsyncClientSettingsPage, AsyncFolders } from './pages';

export function setup(api: PiletApi) {
	setLogger(api.sf.getLogger());

	addBlock(api);

	api.sf.registerClientPage('/settings', () => {
		return <AsyncClientSettingsPage piral={api} params={{}} />;
	});

	api.sf.registerClientPage('/folders', () => {
		return <AsyncFolders piral={api} params={{}} />;
	});

	const smokeTestCustomers = [
		'pilet-tests.sharefiletest.com',
		'pilet-tests.sharefilestaging.com',
		'pilet-tests.sharefile.com',
	];

	if (
		process.env.NODE_ENV === 'development' ||
		smokeTestCustomers.includes(location.hostname)
	) {
		registerDeveloperTools(api);
	}
}

function registerDeveloperTools(piletApi: PiletApi) {
	piletApi.sf.registerLeftNavComponent({
		href: '/client-pilet-block-development',
		title: () => 'Client Pilet Block Dev',
		icon: Cog,
		weight: 50,
	});

	piletApi.registerPage('/client-pilet-block-development', () => (
		<AsyncBlockDevelopmentPage piletApi={piletApi} />
	));
}
